import React, { useState } from 'react';
import { ChevronDownIcon, ChevronUpIcon } from 'lucide-react';
interface FAQItemProps {
  question: string;
  answer: string;
}
export const FAQItem: React.FC<FAQItemProps> = ({
  question,
  answer
}) => {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border-b border-dark-600 py-6" data-id="element-712">
      <button className="flex justify-between items-center w-full text-left" onClick={() => setIsOpen(!isOpen)} data-id="element-713">
        <h3 className="text-lg font-medium text-white" data-id="element-714">{question}</h3>
        <div className="ml-2 flex-shrink-0" data-id="element-715">
          {isOpen ? <ChevronUpIcon className="h-5 w-5 text-[#00c853]" data-id="element-716" /> : <ChevronDownIcon className="h-5 w-5 text-gray-400" data-id="element-717" />}
        </div>
      </button>
      {isOpen && <div className="mt-4 pr-12" data-id="element-718">
          <p className="text-base text-gray-300" data-id="element-719">{answer}</p>
        </div>}
    </div>;
};